import { render, staticRenderFns } from "./InfoPedidoModal.vue?vue&type=template&id=6d9f30c1&scoped=true&"
import script from "./InfoPedidoModal.vue?vue&type=script&lang=js&"
export * from "./InfoPedidoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9f30c1",
  null
  
)

export default component.exports